import {ItemDTO} from '../components/user/on-sale/types';

export type TradeStatus =
    | 'WAITING_FOR_SELLER_CONFIRM'
    | 'WAITING_FOR_SELLER_CONFIRM_CANCELLED'
    | 'WAITING_FOR_SELLER_SEND'
    | 'WAITING_FOR_SELLER_SEND_CANCELLED'
    | 'WAITING_FOR_BUYER_ACCEPT'
    | 'WAITING_FOR_BUYER_ACCEPT_CANCELLED'
    | 'WAITING_FOR_VERIFICATION'
    | 'WAITING_FOR_VERIFICATION_CANCELLED'
    | 'LOGIN_SECURE_SELLER_VERIFICATION_REQUIRED'
    | 'LOGIN_SECURE_BUYER_VERIFICATION_REQUIRED'
    | 'COMPLETED'
    | 'COMPLETED_CANCELLED'
    | 'SYSTEM_CANCELLED';

export type TradeCancelType =
    | 'SELLER_CANCELLED'
    | 'SELLER_ACCEPT_EXPIRED'
    | 'SELLER_SENT_EXPIRED'
    | 'SELLER_TRADE_ABORT'
    | 'SELLER_TRADE_REVERSAL'
    | 'BUYER_CANCELLED'
    | 'BUYER_ACCEPT_DECLINED'
    | 'BUYER_TRADE_ABORT'
    | 'BUYER_TRADE_REVERSAL'
    | 'SYSTEM_CANCEL'
    | 'SYSTEM_CANCEL_SYSTEM_FAULT'
    | 'SYSTEM_CANCEL_BUYERS_FAULT'
    | 'SYSTEM_CANCEL_SELLERS_FAULT';

export type SteamTradeOfferStatusType =
    | 'INVALID'
    | 'ACTIVE'
    | 'ACCEPTED'
    | 'COUNTERED'
    | 'EXPIRED'
    | 'CANCELED'
    | 'DECLINED'
    | 'INVALIDITEMS'
    | 'CREATEDNEEDSConfirmation'
    | 'CANCELLEDBYSecondFactor'
    | 'INESCROW';

export type ExtensionTradeStatusType =
    | 'NEEDS_MOBILE_CONFIRMATION'
    | 'ACCEPTED'
    | 'DECLINED';

export interface Trade {
    id: string;
    offerId: string;
    buyGroupId: string;
    sellGroupId: string;
    tradeGroupId: string | null;
    tradeGroupLocked: boolean | null;
    effectiveTradeStatus: TradeStatus;
    effectiveSteamTradeOfferStatus: SteamTradeOfferStatusType | null;
    statusUpdateDate: string | Date | null;
    priceMinor: number;
    item: ItemDTO;
    sellerUserId: number;
    sellerSteamAccountId: number;
    sellerSteamAvatarUrl: string | null;
    sellerSteamProfileUrl: string | null;
    buyerUserId: number;
    buyerSteamAccountId: number;
    buyerSteamAvatarUrl: string | null;
    buyerSteamProfileUrl: string | null;
    snapshotJson: string;
    creationDate: string;
    steamTradeId?: string | number | null;
    extensionTradeStatus: ExtensionTradeStatusType | null;
}

export interface TradeGroup {
    id: string;
    locked: boolean;
    tradeStatus: TradeStatus;
    cancelType: TradeCancelType | null;
    statusUpdateDate: string | Date | null;
}

export interface PageResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
}

export type ViewMode = 'sold' | 'purchased';

export const wearMap: Record<string, string> = {
    FACTORY_NEW: 'FN',
    MINIMAL_WEAR: 'MW',
    FIELD_TESTED: 'FT',
    WELL_WORN: 'WW',
    BATTLE_SCARRED: 'BS',
};

export const fullSequence: TradeStatus[] = [
    'WAITING_FOR_SELLER_CONFIRM',
    'WAITING_FOR_SELLER_SEND',
    'WAITING_FOR_BUYER_ACCEPT',
    'WAITING_FOR_VERIFICATION',
    'COMPLETED'
];

export const statusToStepKey: Record<string, TradeStatus> = {
    'WAITING_FOR_SELLER_CONFIRM_CANCELLED': 'WAITING_FOR_SELLER_CONFIRM',
    'WAITING_FOR_SELLER_SEND_CANCELLED': 'WAITING_FOR_SELLER_SEND',
    'WAITING_FOR_BUYER_ACCEPT_CANCELLED': 'WAITING_FOR_BUYER_ACCEPT',
    'WAITING_FOR_VERIFICATION_CANCELLED': 'WAITING_FOR_VERIFICATION',
    'COMPLETED_CANCELLED': 'WAITING_FOR_VERIFICATION'
};